import React from 'react';

import { routes } from 'navigation/routing';
import { t } from 'state/intl/translations';
import { useIsLoyaltyEnabled } from 'state/loyalty/hooks/use-is-loyalty-enabled';

import { TermsLink } from '../styled';

export const RewardsPolicyTermsLink = () => {
  const loyaltyEnabled = useIsLoyaltyEnabled();

  if (!loyaltyEnabled) {
    return null;
  }
  return <TermsLink to={routes.termsConditionsRewards}>{t('rewardsPolicy')}</TermsLink>;
};
